---
title: Tarif, Extras & Rechnungen
parent: Dokumentation
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Tarif, Extras, Rechnungen & rechtliche Seiten

## Ein Tarif mit allem inklusive

TOBY hat einen vollständigen Tarif ohne Einrichtungsgebühr und ohne versteckte Stufen:

- **Monatlich oder jährlich:** Wählen Sie zwischen flexibler monatlicher Abrechnung (monatlich jederzeit kündbar) oder vergünstigter jährlicher Abrechnung (auch per Rechnung zahlbar / Kauf auf Rechnung). Alle aktuellen Preise finden Sie in der [Preisliste](/de/pricing).

Jedes Abonnement enthält:

- **Ihre eigene Domain** (<DomainTlds />) — inklusive Übertragung einer bestehenden Domain (Domain-Umzug)
- **1 E-Mail-Adresse** (info@...) mit einem **15 GB Postfach (Maxi-Postfach)** und unbegrenzten Weiterleitungsadressen
- **Bis zu 15 Seiten** — erstellt und gepflegt per Chat, Sprache oder Foto-Upload
- **1 zusätzliche Sprache** (2 Sprachen insgesamt) mit automatischer Übersetzung beim Veröffentlichen
- **Newsletter** mit **1.000 E-Mails / Monat**
- **Besucherstatistiken** (datenschutzfreundlich, ohne Cookie-Banner)
- **Starter-Paket per Post** (Türaufkleber und A5 QR-Tischaufsteller)
- **Hosting in der EU** mit automatischer SSL-Sicherheit

## Optionale Extras

Wenn Ihr Unternehmen über die enthaltenen Limits hinauswächst, können Sie unter **Einstellungen → Abonnement** jederzeit flexible Bausteine (monatlich kündbar, siehe [Preisliste](/de/pricing)) hinzufügen:

- **+15 GB E-Mail-Speicher** (oder ein zusätzliches Postfach)
- **+1 zusätzliche Website-Sprache**
- **+15 zusätzliche Seiten**
- **+5.000 Newsletter-E-Mails / Monat**

## Eine ordentliche Rechnung erhalten (Website vs. Google Play)

Wenn Sie ein Unternehmen, eine Praxis oder ein Freelancer-Konto betreiben und eine **ordentliche Rechnung** mit Ihrem Firmennamen, Ihrer Geschäftsadresse und separat ausgewiesener MwSt. benötigen, beachten Sie bitte, wo Sie abonnieren:

- **Abonnement auf der Website (tobysite.com über Stripe):** Sie erhalten immer eine **ordentliche Rechnung mit MwSt.** von uns, adressiert an Ihr Unternehmen. Sie können alle vergangenen Rechnungen herunterladen und Ihre Firmen-Rechnungsadresse jederzeit unter **Einstellungen → Abonnement** aktualisieren.
- **Abonnement in der Android-App (Google Play In-App-Kauf):** Wenn Sie über Google Play abonnieren, verarbeitet Google die Zahlung als Händler und stellt nur eine Standard-Google-Play-Zahlungsquittung aus. **Wir können keine ordentliche Rechnung für Abonnements ausstellen, die über Google Play abgerechnet werden.**

> **Tipp:** Sie können auf **tobysite.com** in Ihrem Browser abonnieren, um ordentliche Stripe-Rechnungen zu erhalten, und trotzdem die TOBY Android- und iOS-Apps ohne Aufpreis mit Ihrem Konto nutzen.

## Ihr Impressum und Ihre Datenschutzerklärung hinzufügen

- **Ihr eigener rechtlicher Text:** Da rechtliche Anforderungen von Ihrer Unternehmensstruktur, Ihrem Beruf und Ihrem Land abhängen, **erstellt TOBY keine Rechtsberatung und schreibt keine rechtlichen Texte (Impressum oder Datenschutzerklärung) eigenständig.**
- **So fügen Sie sie hinzu:** Fügen Sie einfach Ihren bestehenden Impressums- oder Datenschutztext in den Chat ein (oder laden Sie ihn als Word-/PDF-Dokument hoch, oder bitten Sie TOBY, ihn von Ihrer alten Website zu übernehmen) und sagen Sie *„Füge dies auf unserer Impressum-Seite ein."* TOBY erstellt die Seiten und verlinkt sie sauber in der Fußzeile Ihrer Website.
